import AppHeader from "./Components/AppHeader";
import AppList from "./Components/AppList";

function App() {
  return (
    <div className="flex flex-col justify-center items-center gap-2">
      <AppHeader />
      <AppList />
    </div>
  );
}

export default App;
